import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/recastsoftware.webp';
import screenshot_target from '../../../images/letterfunnel/donnyvanderlinde.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Donny van der Linde"
      firstname="Donny"
      companyname="Recast Software"
      competition="Patch My PC en Ivanti"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/donnyvanderlinde.js